<np-header
  [sitename]="'CAIRA'"
  [menuItems]="navigationItems"
  [hasEnterpriseSearch]="false"
></np-header>
<np-nav [navItems]="navigationItems"></np-nav>

@if (welcomeMessage) {
  <div class="logout">
    <div class="userDetails">
      <div>
        <img ngSrc="assets/_images/user.png" fill priority class="user-image" />
      </div>
      <div>
        <h2 class="mb-0">{{ welcomeMessage }}</h2>
        <!-- <p class="mb-0">[US West - Administrator]</p> -->
      </div>
    </div>
    <!-- TODO LOGOUT Functionality -->
    <!-- <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#0b2d71"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      (click)="signOut()"
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg> -->
  </div>
}
